<template>
    <vs-popup title="MODIFIER UNE CATÉGORIE"
              :active.sync="isPromptActiveLocal">

        <div class="container">
            <div class="row justify-content-md-center">
                <div>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                        <vs-input v-model="category.name" class="w-full" name="name" label="Nom"
                                  :danger="!!formErrors.name"
                                  :danger-text="formErrors.name ? formErrors.name[0] : ''"
                                  v-on:input="resetErrors('name')"/>
                    </vs-col>

                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                        <vs-input v-model="category.description" class="w-full mt-2" label="Description"
                                  name="description"
                                  :danger="!!formErrors.description"
                                  :danger-text="formErrors.description ? formErrors.description[0] : ''"
                                  v-on:input="resetErrors('description')"/>
                    </vs-col>

                    <vs-button color="primary" class="mt-2 mr-2" type="filled" @click="saveItem()">Modifier</vs-button>
                    <vs-button color="primary" class="mt-2" type="border" @click="$emit('closePrompt')">Annuler
                    </vs-button>
                </div>
            </div>
        </div>
    </vs-popup>
</template>

<script>
    export default {
        name: "update",
        props: {
            isPromptActive: {
                type: Boolean,
                required: true
            },
            category: {
                type: Object
            },
            updateCallBack: {
                type: Function
            }
        },
        watch: {
            isPromptActive(val) {
                if (!val) return;
            }
        },
        computed: {
            isPromptActiveLocal: {
                get() {
                    this.formErrors = {}
                    return this.isPromptActive
                },
                set(val) {
                    if (!val) {
                        this.$emit('closePrompt')
                    }
                }
            },
        },
        data: () => ({
            formErrors: {}
        }),
        methods: {
            saveItem() {
                this.$vs.loading()
                this.$http.put('/categories/subjects/' + this.category.slug, this.category).then((response) => {
                    this.$vs.loading.close()
                    if (response.data.slug) {
                        this.formErrors = {}
                        this.$vs.notify({
                            title: 'Succès',
                            text: 'Opération effectuée avec succès',
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check',
                            position: 'top-right'
                        })
                        this.$emit('closePrompt')
                        this.resetErrors()
                        this.updateCallBack()
                    }
                }).catch((error) => {
                    this.$vs.loading.close()
                    if (error.response.status === 401) {
                        this.$vs.notify({
                            title: 'Erreur',
                            text: 'Votre session a expiré',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-check',
                            position: 'top-right'
                        })
                        this.$router.push({name: "login"})
                    } else {
                        this.$vs.notify({
                            title: 'Erreur',
                            text: 'Veuillez valider les champs du formulaire',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-check',
                            position: 'top-right'
                        })
                        this.formErrors = error.response.data.errors
                    }

                })
            },
            resetErrors(field) {
                if (field) {
                    this.formErrors[field] = null;
                } else {
                    this.formErrors = [];
                    Object.keys(this.category).forEach(index => (this.category[index] = null));
                }
            },
        }
    }
</script>

<style scoped>

</style>